<template>
  <div class="sf-el text-item">
    <div class="sf-text">
      <p v-html="resolvedContent"></p>
    </div>
  </div>
</template>

<script>
  import { toRef } from 'vue';
  import { useDynamicContent } from '@shared/composables/useDynamicContent';

  export default {
    name: 'TextElement',
    props: {
      content: String,
      parameters: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const resolvedContent = useDynamicContent(toRef(props, 'content'), props.parameters);

      return {
        resolvedContent,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-text {
    color: var(--cs-text-body);
    p {
      color: inherit;
    }
  }
</style>
